const PROCEDURAL_BREAK_REGEX = /([^\n])\s+(?=([a-z]\)|\d+(?:\.\d+)+\.?)\s*)/gi

export function formatProceduralText(text) {
    return String(text || '')
        .replace(PROCEDURAL_BREAK_REGEX, '$1\n\n')
        .replace(/\n{3,}/g, '\n\n')
}
